export default function ReactivateIcon({ width = 12, height = 12, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g fill='currentColor' fillRule='nonzero'>
        <path d='M12,2 C6.48,2 2,6.48 2,12 L0,12 L4,16 L8,12 L5,12 C5,8.13 8.13,5 12,5 C15.87,5 19,8.13 19,12 C19,15.87 15.87,19 12,19 C10.07,19 8.32,18.21 7.06,16.94 L5.64,18.36 C7.27,19.99 9.51,21 12,21 C17.52,21 22,16.52 22,12 C22,6.48 17.52,2 12,2 Z' />
        <path d='M11,7 L11,13 L16.25,16.15 L17,14.92 L12.5,12.25 L12.5,7 Z' />
      </g>
    </svg>
  );
}
